import { ControlPanelProvider } from '@bs/control-panel'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { PantryProvider } from '@pantry/features'
import type { ReactNode } from 'react'
import { FLAGS } from '~/constants/flags'
import { useAuth } from '~/modules/auth/redux/hook'
import { useActiveStore, useSelectedStore } from '~/redux/hooks/store'
import { useHubspotTracking } from '~/utils/hooks/useHubspotTracking'
import { usePantryUI } from '~/utils/hooks/usePantryUI'
import AdminLayout from './Admin'
import PantryAdminLayout from './PantryAdmin'

interface AdminLayoutSelectorProps {
  children: ReactNode
}

const AdminLayoutSelector = ({ children }: AdminLayoutSelectorProps) => {
  const activeStore = useSelectedStore()
  const { actions: authActions } = useAuth()
  const { isPantryUI, isPosNewUI } = usePantryUI(activeStore)

  const isHubspotEnabled = useFeatureIsOn(FLAGS.BS_ENABLED_HUBSPOT)
  useHubspotTracking(isHubspotEnabled)

  const Layout = isPantryUI ? PantryAdminLayout : AdminLayout

  return (
    <ControlPanelProvider store={activeStore}>
      <PantryProvider
        store={activeStore}
        // Regular POS stores on the Pantry UI need nav + warehouses too,
        // otherwise PantryRoleGuard has no allow-list and blocks every page.
        enabled={!!activeStore?.isPantry || isPosNewUI}
        onRefreshStore={() =>
          (authActions.checkAuthState as unknown as () => void)()
        }
      >
        <Layout>{children}</Layout>
      </PantryProvider>
    </ControlPanelProvider>
  )
}

export default AdminLayoutSelector
